<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" lg="12">
            <CRow>
                <CCol sm="12" lg="12">
                    <div style="margin: 5%">
                        <CContainer>
                            <div class="text-left">
                                <br /><br /><br />
                                <h1 class="custom-40px-600">
                                    Borang Laporan Polis
                                </h1>
                                <p class="custom-16px-400 font-color-98A2B3 text-left mb-4">Maklumat untuk membantu pihak berkuasa menangani aduan anda dengan lebih efisien.</p>
    
                                <h3 class="custom-20px-600">Maklumat Peribadi</h3>
                                <h4 class="custom-16px-400">Nama Penuh:</h4>
                                <input type="text" class="custom-input-grey" v-model="FullName"/>
                                <CRow class="mt-3">
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Nombor Telefon:</h4>
                                        <input type="text" class="custom-input-grey" v-model="Phone"/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Emel:</h4>
                                        <input type="text" class="custom-input-grey" v-model="Email"/>
                                    </CCol>
                                </CRow>
                                <h4 class="custom-20px-600 mt-3">Butiran Aduan</h4>
                                <h4 class="custom-16px-400">Penerangan Aduan:</h4>
                                <CTextarea type="text" rows="9" v-model="Description"/>

                                <CRow class="mt-3">
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Tarikh Kejadian:</h4>
                                        <input type="date" class="custom-input-grey" v-model="ReportDate"/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h4 class="custom-16px-400">Lokasi Kejadian:</h4>
                                        <input type="text" class="custom-input-grey"   v-model="Locations"/>
                                    </CCol>
                                </CRow>

                                <h4 class="custom-20px-600 mt-3">Bukti Sokongan</h4>
                                <CTextarea type="text" rows="9" />

                                <h4 class="custom-20px-600 mt-3">Tandatangan</h4>
                                <CTextarea type="text" rows="9" />

                                <input type="checkbox" /><label class="custom-16px-400 ml-3">Saya mengesahkan bahawa maklumat yang telah saya berikan adalah benar.</label>
                                <div class="text-right">

                                    <!-- <CButton class="bg-border-26224E">Simpan & Hantar Laporan</CButton> -->
                                    <CButton class="bg-26224E ml-2 text-white" @click="UpdateReport()">Simpan & Hantar Laporan</CButton>
                                </div>
                            </div>
                        </CContainer>
                    </div>
                    <br />
    
                </CCol>
    
            </CRow>
        </CCol>
        <div v-if="showSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img src="../assets/img/smallicon/successicon.png" width="100px"/>
                    <h3 class="custom-28px-600 text-center">
                        Terima kasih, laporan anda telah diterima
                    </h3>
                    <p class="font-color-6C7278 text-center">Laporan anda sedang disemak oleh sistem. Anda akan menerima notifikasi apabila laporan telah diproses sepenuhnya.</p>
                </div>
                <div class="justify-content-between m-0 text-center">
                    <CButton class="custom-border-26224E p-2" @click="ClosePopupUpload()"><span class="ml-2 mr-2 font-color-171717">Kembali</span></CButton>

                </div>
            </div>
        </div>
                
    </div>
</template>


<script>
import Vue from "vue";

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/WhiteHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import { CTextarea } from "@coreui/vue";

export default {
    name: "Login",
    components: {
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            isActive: false,
            Names: "",
            loading: true,

            FullName:"",
            Phone:"",
            Email: "",
            ReportDate: "",
            Locations: "",
            Description: "",
            ReportId: "",

            showSuccess: false


        };
    },
    created() {
    },
    async mounted() {
        this.GetDetailReport();

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetDetailReport();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GoToVideo() {
            this.$router.push("InterviewerrVideo");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("HowItWork");
                console.error("Error fetching user info:", error);
            }
        },
        async GetDetailReport() {
            try {
                const response = await this.$API.get(this.$GetReportDetails + "?id=" + this.$route.query.id, { 
                    withCredentials: true 
                });
                if (response.status === 200) {
                    this.info = response.data;
                    if (response.status == 200 && this.info != null) {
                        this.FullName = this.info.FullName;
                        this.Email = this.info.Email;
                        this.Phone = this.info.Phone;
                        this.Description = this.info.Description;
                        this.ReportDate = this.info.ReportDate;
                        this.Locations = this.info.Locations;
                        this.ReportId = this.info.ReportId;
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        UpdateReport() {

            const formData = new FormData();
            formData.append("SessionId", this.$route.query.id);
            formData.append("FullName", this.FullName);
            formData.append("Email", this.Email);
            formData.append("Phone", this.Phone);
            formData.append("ReportId", this.ReportId);
            formData.append("Description", this.Description);
            formData.append("ReportDate", this.ReportDate);
            formData.append("Locations", this.Locations);


            this.$API
                .post(this.$UpdateReport, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            this.showSuccess = true;

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        ClosePopupUpload()
        {
            this.showSuccess = false;
            this.$router.push("/");
        }
    },

};
</script>

<style scoped>
.c-header.c-header-fixed {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1029;
    background: #fff;
    background-size: cover;
}
</style>
